import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { LanguageProvider } from './lib/i18n.jsx';
import { ThemeProvider } from './lib/theme.jsx';
import { AuthProvider } from './lib/auth.jsx';
import { setRuntimeConfig } from './lib/config.js';
import './styles/styles.css';
import './styles/portal.css';

async function boot() {
  // Optional runtime config (for "build once, deploy anywhere"). The build ships
  // an empty public/config.json; a deployment may mount its own over it.
  try {
    const r = await fetch('/config.json', { cache: 'no-store' });
    if (r.ok && (r.headers.get('content-type') || '').includes('json')) {
      setRuntimeConfig(await r.json());
    }
  } catch {
    // unreachable or invalid — fall back to VITE_API_BASE
  }
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <BrowserRouter>
        <LanguageProvider>
          <ThemeProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ThemeProvider>
        </LanguageProvider>
      </BrowserRouter>
    </StrictMode>,
  );
}

boot();
